<div *ngIf="showTimer" class="timer-container">
    <h2 *ngIf="!isInFuture">Temps restant</h2>
    <h2 *ngIf="isInFuture">Début dans</h2>
    <div class="timer">{{ formattedTime }}</div>
    <div class="progress-bar">
        <div [style.width.%]="progressPercentage"></div>
    </div>
</div>